import { combineReducers } from "redux";
import mediaStreamReducer from "./StreamState/reducer/reducer";

const rootReducer = combineReducers({
  mediaStream: mediaStreamReducer,
  // Add other reducers here
});
export default rootReducer;
